module.exports = __webpack_public_path__ + "static/media/v3.f67f4465.png";